import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'react-feather';

const SingleCampaign = (props) => (
    <div className={props.classes}>
        {props.schedule === 'Y' &&
            <div className="position-absolute p-1 rounded d-flex align-items-center shadow" style={{top: 5, right: 5, backgroundColor: "#ffc107", border: "1px solid rgba(0,0,0,0.5)"}}>
                <Calendar size="14" data-tip="This campaign runs on a schedule." />
            </div>
        }
        <Link
            to={`/campaign/${props.campaignId}`}
            className="mb-card-img-top"
            style={{ backgroundImage: `URL(${ props.thumbnail })` }}>        
        </Link>
        <div className="card-body d-flex flex-column justify-content-between text-left">
            <p className="font-weight-bold">{ props.name }</p>
            <div className="mb-campaign-price text-center">
                {props.rate}
            </div>
        </div>
    </div>
);

export default SingleCampaign;